'use client'

import DotsLoader from '@precis-digital/kurama/DotsLoader'
import React, { type ReactElement } from 'react'

const Dots = (): ReactElement => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center'
      }}
    >
      <DotsLoader height={30} width={30} radius={9} />
    </div>
  )
}

export default Dots
